export const listsRoutes = {
  attractions: '/api/Prebook/Booking/GetListOfAttractions',
  tickets: 'https://assets.codepen.io/19711/tickets.json',
  attractionAvailability: '/api/Prebook/Booking/GetAttractionAvailability'
};

export const passesForAttractionRoute = (attractionid: string) => {
  return `/api/Prebook/Booking/GetListOfPassesForAttraction/${attractionid}`;
};

export const passRoutes =  {
    add: '/api/Prebook/Pass/AddPass',
    remove: `/api/PreBook/Pass/RemovePass`
}

export const attractionAvailabilityRoute = (passtypes: string, attractionid: string, fromDate: string) => {
  return `/api/Prebook/Booking/GetAttractionAvailability?passtypes=${passtypes}&attractionid=${attractionid}&from=${fromDate}`;
};

export const bookingRoutes = {
  cancelBooking: `/api/Prebook/Booking/CancelBooking`,
  createReservation: '/api/Prebook/Booking/CreateReservation',
  convertReservationToBooking: '/api/Prebook/Booking/ConvertReservationToBooking',
  getTickets: '/api/Prebook/Booking/GetTickets',
};